import { PDFViewerMode, PDFZoomPreset } from "flow/interfaces/PDFViewer";
import baseUrl from "flow/wrappers/baseUrl";
import moduleLoader from "flow/wrappers/moduleLoader";

export interface IPDFViewerOptions {
    url: string;
    width: string;
    height: string;
    mode: PDFViewerMode;
    zoom: PDFZoomPreset | number | string;
}

const mobileRegex = new RegExp(/iPhone|iPad|iPod|Android/i);
const macintoshRegex = new RegExp(/Macintosh/i);

export function setupPdfViewer(element: HTMLElement, opts: IPDFViewerOptions | string) {
    const options: IPDFViewerOptions =
        typeof opts === "string"
            ? {
                  url: opts,
                  width: "100%",
                  height: "100%",
                  mode: PDFViewerMode.Auto,
                  zoom: PDFZoomPreset.Auto
              }
            : opts;

    const isMobileDevice =
        mobileRegex.test(navigator.userAgent) ||
        (macintoshRegex.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1);

    element.textContent = "";
    const viewer = document.createElement("iframe");
    viewer.style.border = "0px";
    viewer.width = options.width;
    viewer.height = options.height;
    viewer.src = options.url;

    if (options.mode == PDFViewerMode.PDFJS || (options.mode === PDFViewerMode.Auto && isMobileDevice)) {
        const hash = options.zoom ? `#zoom=${options.zoom.toString()}` : "";
        const cacheBuster = `bust=${moduleLoader.getCacheBuster("framework/") || Date.now()}`;
        viewer.src = `${baseUrl}dist/pdf/web/viewer.html?${cacheBuster}&file=${encodeURIComponent(options.url)}${hash}`;
    }

    element.append(viewer);
}
